export const css = {
    root: '_3AIUp5eI',
    menu: '_1NGpOLnF',
    divider: '_6zqq4QeV',
    ' _key': 'certwise-theme/dojo/list'
};
export default css;
